import React from 'react';
import { Building, FileText, Palette, Home, TrendingUp, MapPin } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: 'Real Estate Mandate',
      description: 'We assure builders for selling their inventory within stipulated time with proven marketing strategies and extensive buyer networks.',
      features: ['Guaranteed Sales Timeline', 'Market Analysis', 'Buyer Networking', 'Sales Strategy']
    },
    {
      icon: <MapPin className="w-8 h-8" />,
      title: 'Plot Feasibility Analysis',
      description: 'Comprehensive feasibility studies to determine the viability and potential of your plot for development projects.',
      features: ['Site Analysis', 'Market Research', 'Financial Projections', 'Risk Assessment']
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: 'Landscape Design',
      description: 'Creative and functional landscape designs that enhance property value and create stunning outdoor spaces.',
      features: ['Custom Designs', '3D Visualization', 'Sustainable Planning', 'Implementation Support']
    },
    {
      icon: <Building className="w-8 h-8" />,
      title: 'Elevation Layout',
      description: 'Professional elevation designs that combine aesthetics with functionality for impressive building facades.',
      features: ['Modern Aesthetics', 'Structural Planning', 'Material Selection', 'Detailed Drawings']
    },
    {
      icon: <Home className="w-8 h-8" />,
      title: 'Builder Floor Plans',
      description: 'Detailed and optimized floor plans designed to maximize space utilization and meet builder specifications.',
      features: ['Space Optimization', 'Vastu Compliance', 'Regulatory Approvals', 'Multiple Variations']
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: 'Complete Documentation',
      description: 'End-to-end documentation support including approvals, permits, and legal compliance for construction projects.',
      features: ['Legal Compliance', 'Permit Processing', 'Document Management', 'Timeline Tracking']
    }
  ];

  return (
    <section id="services" className="py-32 px-4 sm:px-6 lg:px-8 bg-white relative" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header - Premium Typography */}
        <div className="text-center mb-20 scroll-reveal">
          <div className="inline-block mb-6">
            <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-gray-500 bg-gray-100 px-6 py-2 rounded-full">What We Offer</span>
          </div>
          <h2 className="text-5xl lg:text-[3.5rem] font-bold text-gray-900 mb-6 leading-[1.1] tracking-tight">
            Our <span className="gradient-text">Services</span>
          </h2>
          <p className="text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto font-light leading-[1.7] tracking-tight">
            Comprehensive solutions for all your real estate and construction needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="scroll-reveal group bg-white border-2 border-gray-100 rounded-3xl p-10 card-hover hover:border-gray-300 transition-all duration-500"
              style={{ transitionDelay: `${index * 100}ms` }}
              data-testid={`service-card-${index}`}
            >
              <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center text-gray-900 mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                {service.icon}
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-black transition-colors duration-300 leading-tight tracking-tight">{service.title}</h3>
              
              <p className="text-gray-600 mb-8 leading-[1.7] font-light text-[17px] tracking-tight">{service.description}</p>
              
              <div className="space-y-3">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center space-x-3 group/feature">
                    <div className="w-1.5 h-1.5 bg-black rounded-full group-hover/feature:scale-150 transition-transform duration-300"></div>
                    <span className="text-[15px] text-gray-700 font-medium leading-relaxed">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;